import * as Yup from 'yup';

import { validateProducts } from 'utils/validation';
import { StockTransferType } from 'store/api/stock-transfers';
import { ltlInvoiceNumberSchema } from 'utils/ltl-invoice-number';
import {
  eventSplitSchema,
  isEventSplitType,
} from 'components/stock-transfer-event-split/config';

export const validationSchema = Yup.object().shape({
  ...validateProducts('items'),
  type: Yup.string().required(),
  ltlInvoiceNumber: ltlInvoiceNumberSchema,
  workOrder: Yup.string().nullable().max(255),
  date: Yup.string().required('Date is required'),
  // owner 2026-10-19: the carrier's tracking #, as on a stock order
  trackingNumber: Yup.string().nullable().max(255),
  sourceStorageId: Yup.number().required('Source storage is required'),
  // T-L09 (L14) / owner 2026-10-16: the optional event split, every type
  // but Client -> Client.
  events: Yup.array().when('type', {
    then: () => eventSplitSchema('ltlPrice'),
    is: (value: StockTransferType) => isEventSplitType(value),
  }),
  destinationCompanyId: Yup.number()
    .nullable()
    .when('type', {
      then: (schema) => schema.required('Destination company is required'),
      is: (value: StockTransferType) =>
        value === StockTransferType.ClientToClient,
    }),
  destinationStorageId: Yup.number()
    .nullable()
    .when('type', {
      then: (schema) => schema.required('Destination storage is required'),
      is: (value: StockTransferType) =>
        value !== StockTransferType.ClientToClient,
    }),
});

/**
 * Owner 2026-10-19: the tracking # as the transfer stores it: trimmed, blank
 * = null (not set). The other values are sent as they are; a body without
 * the key stays without it.
 */
export const withTrackingNumber = <
  T extends { trackingNumber?: string | null },
>(
  values: T
): T => {
  if (!('trackingNumber' in values)) {
    return values;
  }
  const trimmed =
    typeof values.trackingNumber === 'string'
      ? values.trackingNumber.trim()
      : '';
  return { ...values, trackingNumber: trimmed || null };
};
